"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Aug 02 2018
 */

var DomainObject_1 = require("../../../core/model/DomainObject");

var MultiTargetStrategy_1 = require("./MultiTargetStrategy");

var SingleTargetStrategy_1 = require("./SingleTargetStrategy");
/**
 * StrategySettings holds settings for {@link Strategy strategy}
 *
 * @author RV
 */


var StrategySettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(StrategySettings, _DomainObject_1$Domai);

  /**
   * Constructs strategy settings instance.
   *
   * @param priceDistance
   * @param strategy
   */
  function StrategySettings(priceDistance, strategy) {
    var _this;

    _classCallCheck(this, StrategySettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(StrategySettings).call(this));
    _this.priceDistance = priceDistance;
    _this.strategy = strategy;
    return _this;
  }
  /**
   * Compares Strategy objects.
   *
   * @param resolvedStrategySettings
   * @returns true if objects are same
   */


  _createClass(StrategySettings, [{
    key: "sameStrategy",
    value: function sameStrategy(resolvedStrategySettings) {
      if (!resolvedStrategySettings) {
        return false;
      }

      if (!this.strategy) {
        return !!resolvedStrategySettings.strategy;
      }

      if (!resolvedStrategySettings.strategy) {
        return false;
      }

      if (this.strategy.getType() !== resolvedStrategySettings.strategy.getType()) {
        return false;
      }

      if (this.strategy instanceof SingleTargetStrategy_1.SingleTargetStrategy && resolvedStrategySettings.strategy instanceof SingleTargetStrategy_1.SingleTargetStrategy) {
        return this.strategy.competitorId === resolvedStrategySettings.strategy.competitorId;
      }

      if (this.strategy instanceof MultiTargetStrategy_1.MultiTargetStrategy && resolvedStrategySettings.strategy instanceof MultiTargetStrategy_1.MultiTargetStrategy) {
        return this.strategy.competitorIds.equals(resolvedStrategySettings.strategy.competitorIds);
      }

      throw new Error("Illegal argument exception for given types ".concat(this.strategy.getType(), " and ").concat(resolvedStrategySettings.strategy.getType()));
    }
    /**
     * Compares two StrategySettings object and removes attributes that are same or return null if they were identical.
     *
     * @param resolvedStrategySettings
     * @returns updated StrategySettings without fields that were same or null if they were identical
     */

  }, {
    key: "diffStrategyWithResolvent",
    value: function diffStrategyWithResolvent(resolvedStrategySettings) {
      var resultStrategySettings = this;

      if (this.priceDistance && resolvedStrategySettings && resolvedStrategySettings.priceDistance && this.priceDistance.range.minimum.equals(resolvedStrategySettings.priceDistance.range.minimum) && this.priceDistance.range.maximum.equals(resolvedStrategySettings.priceDistance.range.maximum)) {
        resultStrategySettings = resultStrategySettings.copy('priceDistance', null);
      }

      if (this.sameStrategy(resolvedStrategySettings)) {
        resultStrategySettings = resultStrategySettings.copy('strategy', null);
      }

      if (!resultStrategySettings.priceDistance && !resultStrategySettings.strategy) {
        return null;
      }

      return resultStrategySettings;
    }
  }]);

  return StrategySettings;
}(DomainObject_1.DomainObject);

exports.StrategySettings = StrategySettings;